var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25608",
    "data-name": "Group 25608",
    transform: "translate(-336 -1144)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 36,
    height: 36,
    transform: "translate(336 1144)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M24,0H3A3.009,3.009,0,0,0,0,3V24a3.009,3.009,0,0,0,3,3H24a3.009,3.009,0,0,0,3-3V3A3.009,3.009,0,0,0,24,0Z",
    transform: "translate(340.5 1148.5)",
    fill: "#ae20ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M.153,5.809l3-4.005a.744.744,0,0,1,1.2,0l2.775,3.7,3.9-5.2a.744.744,0,0,1,1.2,0l4.125,5.505a.75.75,0,0,1-.6,1.2h-15A.75.75,0,0,1,.153,5.809Z",
    transform: "translate(345.747 1162.491)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSmall);
export default __webpack_public_path__ + "static/media/image-small.8e96f500e5dfcea30fa35c60a09c4574.svg";
export { ForwardRef as ReactComponent };